import React, { useEffect, useState } from "react";
import T from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import api from "APP_ROOT/api";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { convertFromOutgoingQuote } from "MODULES/OutgoingQuotes/actions";
import Form from "./Form";

function ConvertToSalesOrder({ history, quote, currentUser, convertQuote }) {
  const [inventories, setInventories] = useState([]);
  useEffect(
    () => {
      const ids = quote.outgoing_quote_line_items
        .map(o => o.inventory_id)
        .filter(f => f);

      if (ids.length > 0) {
        api.inventories
          .search({
            ids,
            all: true
          })
          .then(({ data: { results } }) => {
            const sortedResult = quote.outgoing_quote_line_items
              .map(o => results.filter(r => r.id === o.inventory_id)[0])
              .filter(f => f);
            setInventories(sortedResult);
          });
      } else {
        setInventories([]);
      }
    },
    [quote]
  );

  return (
    <ToggleSwitch>
      {(visible, open, close) => {
        const onClick =
          quote.outgoing_quote_line_items.length === 1 &&
          inventories.length === 1
            ? () =>
                convertQuote({
                  inventory_ids: inventories.map(i => i.id),
                  outgoing_quote_id: quote.id
                })
            : open;

        return (
          <DropDownItem onClick={onClick} disabled={inventories.length === 0}>
            <Icon name="dollar" fixed />
            &nbsp;Convert To Sales Order
            <Modal open={visible} close={close} dialogClass="modal-lg">
              <Header>
                <Close close={close} />
                <h4 className="modal-title">Convert To Sales Order</h4>
              </Header>
              <Form
                close={close}
                convertQuote={convertQuote}
                inventories={inventories}
                history={history}
                quote={quote}
                currentUser={currentUser}
              />
            </Modal>
          </DropDownItem>
        );
      }}
    </ToggleSwitch>
  );
}

ConvertToSalesOrder.propTypes = {
  quote: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(
  withRouter(
    connect(undefined, (dispatch, ownProps) => ({
      convertQuote: params =>
        dispatch(convertFromOutgoingQuote(params, ownProps.history))
    }))(ConvertToSalesOrder)
  )
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/ConvertToSalesOrder/ConvertToSalesOrder.jsx